import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

export const provider = {
  id: 'microsoft-auth-provider',
  title: 'Ingka SSO',
  message: 'Sign In using your INGKA account',
  apiRef: microsoftAuthApiRef,
};
